import { Button } from "@repo/ui/components/button"
import { FileQuestion } from "lucide-react"
import { Link } from "react-router"

import { EmptyState } from "@/components/page/empty-state"

export function NotFoundPage() {
  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      <EmptyState
        icon={FileQuestion}
        title="Page not found"
        description="That address does not exist, or the page has moved."
      >
        <Button render={<Link to="/" />} nativeButton={false}>
          Go home
        </Button>
      </EmptyState>
    </div>
  )
}
